function getDistance(lat1, lon1, lat2, lon2) {
  const R = 3959; // Radius of the earth in km
  const dLat = deg2rad(lat2 - lat1); // deg2rad below
  const dLon = deg2rad(lon2 - lon1);
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(deg2rad(lat1)) *
      Math.cos(deg2rad(lat2)) *
      Math.sin(dLon / 2) *
      Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const d = R * c; // Distance in km
  return d;
}

// Deg conversion
function deg2rad(deg) {
  return deg * (Math.PI / 180);
}

// Validate the arguments
function validateArgs(lat, long, arr, asc) {
  if (isNaN(parseFloat(lat)) || isNaN(parseFloat(long)) || !arr) {
    throw new Error("Invalid arguments");
  }
  if (typeof lat !== "number" || typeof long !== "number") {
    throw new Error("lat and long should be numbers");
  }
  if (!Array.isArray(arr)) {
    throw new Error("Second argument should be an array");
  }
  if (typeof asc !== "boolean") {
    throw new Error("Asc argument should be a boolean");
  }
}

/**
 * Sort the array according to the user's lat long
 * @param lat {Number} - User's latitude
 * @param long {Number} - User's longitude
 * @param arr {Array} - Array of objects that contain lat and long
 * @param asc {Boolean} - Ascending or descending order
 * @returns {Array} - Sorted array
 */
async function nearbySort({ lat, lng }, arr, asc = true) {
  return new Promise((resolve, reject) => {
    try {
      validateArgs(lat, lng, arr, asc);
      const sortedArray = arr.sort((a, b) => {
        const distanceA = getDistance(lat, lng, a.lat, a.lng);
        const distanceB = getDistance(lat, lng, b.lat, b.lng);

        a.distance = distanceA.toFixed(1);
        b.distance = distanceB.toFixed(1);
        return asc ? distanceA - distanceB : distanceB - distanceA;
      });
      let results = [];
      if (lat != 0 && lng != 0) {
        results = sortedArray.filter((item, index) => {
          if (index > 100) {
            return false;
          }
          return item.distance;
        });
      } else {
        results = sortedArray;
      }
      resolve(results);
    } catch (err) {
      reject(err);
    }
  });
}
